import { User } from "model/user";

// Who sees the IDX page. The page, the sidebar and quick search all read this, so the three can't
// disagree about who reaches it.

/** Admins: the page edits the account's version, platform and IDX pages. */
export function idxPermitted(user: User): boolean {
	return !!user.admin;
}
